import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import { CREATE_CONTRACT } from 'src/store/actions/contractActions';

import StepOne from './StepOne';
import StepTwoo from './StepTwo';
import StepThree from './StepThree';
import StepFour from './StepFour';
import StepFive from './StepFive';
import StepSix from './StepSix';
import FinalStep from './FinalStep';

const CurrentStep = ({
  activeStep,
  data,
  onNext,
  onBack,
  onSubmit,
  open,
  resetRef
}) => {
  const loading = useSelector(isLoadingSelector([CREATE_CONTRACT.action]));

  if (activeStep === 0) {
    return (
      <StepOne
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        open={open}
        resetRef={resetRef}
      />
    );
  }

  if (activeStep === 1) {
    return (
      <StepTwoo
        open={open}
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        resetRef={resetRef}
      />
    );
  }
  if (activeStep === 2) {
    return (
      <StepThree
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        resetRef={resetRef}
      />
    );
  }
  if (activeStep === 3) {
    return (
      <StepFour
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        resetRef={resetRef}
      />
    );
  }
  if (activeStep === 4) {
    return (
      <StepFive
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        resetRef={resetRef}
      />
    );
  }

  if (activeStep === 5) {
    return (
      <StepSix
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        resetRef={resetRef}
      />
    );
  }

  return (
    <FinalStep
      data={data}
      loading={loading}
      handleBack={onBack}
      handleSubmit={onSubmit}
    />
  );
};

CurrentStep.propTypes = {
  activeStep: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  data: PropTypes.any.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  resetRef: PropTypes.object.isRequired
};

export default CurrentStep;
